module.exports = __webpack_public_path__ + "static/b1-anchors1-ba25eede1f0c7c4f8aa97dd3fe86598f.jpg";